module.exports = __webpack_public_path__ + "img/title2.ba4b6004.png";